import { MapComment } from "@nova/protobuf"
import { decideTakeSnapshotOfSecondaryLayer } from "features/map/control/module"
import { panToShowPoint } from "features/map/control/slice"
import { selectMapCommentById } from "features/entity-caching/map-comments/selectors"
import { clearSelection, selectSingleLayer } from "panels/content/side-panel/slice.new"
import { setActiveTool } from "plugins/Toolbox/tool-registry"
import store from "integrations/redux/store"
import { ToolName } from "@nova/constants"

export const zoomToMapComment = (entity: MapComment) => {
    decideTakeSnapshotOfSecondaryLayer()
    store.dispatch(panToShowPoint({ lng: entity.longitude, lat: entity.latitude }))
}

export const selectMapComment = (id: string) => {
    store.dispatch(setActiveTool(undefined))
    store.dispatch(selectSingleLayer({ id }))
}

export const openMapComment = (id: string) => {
    selectMapComment(id)
    const entity = selectMapCommentById(id)(store.getState())
    if (entity) zoomToMapComment(entity)
}

export const backToMapCommentList = () => {
    store.dispatch(clearSelection())
    store.dispatch(setActiveTool(ToolName.Comment))
}

export const closeMapComment = () => {
    store.dispatch(clearSelection())
    store.dispatch(setActiveTool(undefined))
}
